module.exports = __webpack_public_path__ + "static/media/building-child-playing-with-blocks-kneeling-svgrepo-com.99936238.svg";